<template>
  <div
    class="grid grid-cols-1 md:grid-cols-3 gap-2 text-white"
    :class="{'border-2 border-sky-400' : highlight}"
  >
    <div>
      <a
        href="javascript:void(0);"
        class="relative text-center block w-full"
        @click="open"
      >
        <ImageOverlay
          :show="hasWon"
          text="Gewonnen"
        />
        <img
          :src="item.main_image_big"
          class="w-full"
        >
      </a>
    </div>

    <div class="col-span-2">
      <a
        href="javascript:void(0);"
        class="font-bold text-4xl lg:mt-1 truncate"
        @click="open"
        v-text="item.name"
      />

      <div class="grid grid-cols-1 md:grid-cols-2">
        <div class="lg:pr-6">
          <div class="block relative">
            <div class="pb-2">
              <i class="far fa-clock text-[.7rem] -mt-0.5" />
              <span
                v-if="item.ending_handled"
                class="inline font-bold"
              >Veiling is afgelopen</span>
              <span
                v-else-if="item.is_ending"
                class="inline font-bold"
              >Veiling toewijzen</span>
              <span
                v-else
                class="inline font-bold"
                v-text="`${timeLeftToText}`"
              />
            </div>
          </div>

          <p
            class="mt-2 lg:mt-1 block"
          >
            Dit artikel wordt op dit moment LIVE geveild op Twitch! Je betaalt na het winnen van de veiling extra kosten voor de verzending en veilingkosten.
          </p>

          <!-- eslint-disable vue/no-v-html -->
          <span
            class="block mt-2"
            v-html="shippingText"
          />
          <!-- eslint-enable vue/no-v-html -->
        </div>

        <div>
          <div class="block">
            <div class="flex mt-3 items-center lg:flex-col lg:justify-start lg:items-start lg:mt-0">
              <span class="block w-full">Huidig bod:</span>
              <span
                v-if="item.bids.data.length === 0"
                class="block w-full"
              >Door: --</span>
              <span
                v-else
                class="block w-full"
              >Door: {{
                item.bids.data[0].name
              }} om {{ item.bids.data[0].time }}</span>
              <span
                v-if="item.bids.data.length === 0"
                class="text-3xl font-bold lg:text-4xl mt-3"
              >&euro; --</span>
              <span
                v-else
                class="text-3xl font-bold lg:text-4xl mt-3"
                v-text="formatMoney(item.bids.data[0].amount)"
              />
            </div>
          </div>

          <div>
            <div class="flex space-x-3 mb-3 md:space-x-0 md:flex-wrap md:mt-3">
              <div class="flex lg:pl-0 space-x-2 w-full lg:mt-2">
                <input
                  v-model="currentBid"
                  type="number"
                  :placeholder="formatMoney(nextMinimalBid)"
                  :disabled="!enableAutobid"
                  class="w-full placeholder-gray-500 text-black outline-none focus-within:border-sky-400 rounded border border-gray-300"
                  :class="{'bg-gray-300 cursor-not-allowed': !enableAutobid}"
                >
              </div>
            </div>

            <a
              v-if="hasWon"
              href="javascript:void(0);"
              class="bg-sky-200 block text-white font-bold rounded-lg py-2 w-full text-center lg:py-3 lg:mt-3 lg:mb-1 cursor-default"
            >
              <i class="far fa-clock mr-2 text-white" /> Gewonnen
            </a>
            <a
              v-else-if="item.ending_handled"
              href="javascript:void(0);"
              class="bg-sky-200 block text-white font-bold rounded-lg py-2 w-full text-center lg:py-3 lg:mt-3 lg:mb-1 cursor-default"
            >
              <i class="far fa-clock mr-2 text-white" /> Afgelopen
            </a>
            <a
              v-else-if="item.is_ending"
              href="javascript:void(0);"
              class="bg-sky-200 block text-white font-bold rounded-lg py-2 w-full text-center lg:py-3 lg:mt-3 lg:mb-1 cursor-not-allowed"
            >
              <i class="fa fa-spinner fa-spin mr-2 text-white" /> Toewijzen
            </a>
            <a
              v-else-if="autoBid !== null"
              href="javascript:void(0);"
              class="bg-gray-500 hover:bg-gray-600 block text-white font-bold rounded-lg py-2 w-full text-center lg:py-3 lg:mt-3 lg:mb-1"
            >
              <i class="fas fa-gavel text-lg mr-2 text-white" /> Autobod: {{ formatMoney(autoBid) }} <i
                class="fa fa-times text-white"
                @click="deleteAutoBid"
              />
            </a>
            <a
              v-else
              href="javascript:void(0);"
              class="bg-green-500 hover:bg-green-600 block text-white font-bold rounded-lg py-2 w-full text-center lg:py-3 lg:mt-3 lg:mb-1"
              @click="bidOnAuction"
            >
              <i class="fas fa-gavel text-lg mr-2 text-white" /> Plaats bod
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Auction from '../../Mixins/Auction';

export default {
  mixins: [Auction],
};
</script>
